/* 🤖 this file was generated by svg-to-ts*/
export const icoZap: {
  name: 'zap';
  data: string;
} = {
  name: 'zap',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.367 11.226l-.09.082a1 1 0 00.48 1.662l6.719 1.68-3.344 5.854c-.539.942.6 1.947 1.468 1.296l12-9 .09-.076a1 1 0 00-.448-1.694l-6.861-1.716 2.538-5.92c.412-.962-.742-1.83-1.552-1.168l-11 9z" fill="#909090"/></svg>`
};
